import { Injectable } from '@angular/core';
import { Subject,Observable,interval,Subscription } from "rxjs";
import { takeWhile } from "rxjs/operators";

export class FvmsAlertMessage {
    id:string;
    level:string;
    icon:string;
    title:string;
    body:string;
    dateUpdate:number;
}

@Injectable({providedIn: 'root'})
export class FvmsAlertService {
    listMessage:FvmsAlertMessage[] = [];
    subjectListMessage:Subject<FvmsAlertMessage[]> = new Subject<FvmsAlertMessage[]>();

    getListMessage():Observable<FvmsAlertMessage[]>{
        return this.subjectListMessage.asObservable();
    }

    alert(alertObject:FvmsAlertMessage){
        //this.subject.next(alertObject);
        alertObject.dateUpdate = new Date().valueOf();
        this.listMessage.push(alertObject);
        this.subjectListMessage.next(this.listMessage);
    }

    removeMessage(id:string){
        let newList = this.listMessage.filter(item => {
            return item.id !== id;
        });
        this.listMessage = newList;
        this.subjectListMessage.next(this.listMessage);
    }

    // interval(1000)
    //     .pipe(takeWhile(() => this.isContinue))
    //     .subscribe(() => this.timerQueue());

    timerQueue(){
        let dateCurrent = new Date().valueOf();
        //5초가 지난 메세지는 자동 삭제
        let newList = this.listMessage.filter(item => {
            let diff = dateCurrent - item.dateUpdate;
            return diff < 5000;
        });
        this.listMessage = newList;
        this.subjectListMessage.next(this.listMessage);
    }

    testData(){
        // let isContinue = true;
        // interval(1000)
        //     .pipe(takeWhile(() => isContinue))
        //     .subscribe(() => {
        //         if(this.listMessage.length > 5){
        //             isContinue = false;
        //         }
        //         let alertItem = {
        //             id: `test-alert-${new Date().valueOf().toString()}`
        //             ,level: "info"
        //             ,icon: "fas fa-wifi"
        //             ,title: "[테스트]차량상태요청 결과" + this.listMessage.length
        //             ,body: "<strong>01212345678</strong> 단말에 보낸 차량상태요청이 실패했습니다"
        //             ,dateUpdate: new Date().valueOf()
        //         };
        //         this.alert(alertItem);
        //     });
    }
}
